import { Box, Stack, Typography } from '@mui/material';
import { useWagmiAuth } from 'app/providers';
import { userModel } from 'entities/user';
import { COLOR_PRIMARY, fromDecimals, smartRound, useShallowSelector } from 'shared';

import { getUserTierInfo } from '../../lib';
import { BonusTip } from '../bonus-tip';

export const UserStats = () => {
  const { state: authState } = useWagmiAuth();
  const { tier, totalSpend } = useShallowSelector(userModel.selectors.selectUserCrowdsaleInfo);
  const spend = smartRound(+fromDecimals(totalSpend), 2);
  const [currentTier] = getUserTierInfo(Number(tier));

  return (
    <Stack mt={3}>
      <Typography className="secondary">
        Your total investments:{' '}
        <Box component="span" color={COLOR_PRIMARY}>
          ${spend}
        </Box>
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <Typography className="secondary">
          Your level is{' '}
          <Box component="span" color={COLOR_PRIMARY}>
            ${currentTier.bonusPercent}% bonus
          </Box>
        </Typography>
        {authState.isAuthorized && <BonusTip />}
      </Stack>
    </Stack>
  );
};
